import dayjs from 'dayjs';

export function parseQuarterMonthDropdownLabel(
  quarterMonth: string,
  currentOpenMonth: string
): [string, boolean] {
  const quarterMonthDate = dayjs(quarterMonth);
  const currentOpenMonthDate = dayjs(currentOpenMonth);

  const isSameMonth = quarterMonthDate.isSame(currentOpenMonthDate);
  const isAfterMonth = quarterMonthDate.isAfter(currentOpenMonthDate);

  const monthStatus = isSameMonth || isAfterMonth ? 'Open' : 'Closed';

  const quarterMonthFormatted = quarterMonthDate.format('MMMM YYYY');

  const label = isAfterMonth
    ? `${quarterMonthFormatted}`
    : `${quarterMonthFormatted} (${monthStatus})`;

  return [label, isAfterMonth];
}
